var productName = 'scheduler';// region Symlinks ("grunt symlink" task)
export * from './webpack.core.entry.thin.js';
export * from './webpack.grid.entry.thin.js';
//endregion
// region Thin bundle
export * from './webpack.entry.thin.js';
// endregion
// region Class renaming
export {
    // feature
    GroupSummary as GridGroupSummary,
    Summary as GridSummary,
    // export feature
    MultiPageExporter as GridMultiPageExporter,
    MultiPageVerticalExporter as GridMultiPageVerticalExporter,
    PdfExport as GridPdfExport,
    SinglePageExporter as GridSinglePageExporter,
    // feature experimental
    ExcelExporter as GridExcelExporter
} from './webpack.grid.entry.thin.js';
export {
    // feature
    GroupSummary,
    Summary,
    // export feature
    MultiPageExporter,
    MultiPageVerticalExporter,
    PdfExport,
    SinglePageExporter,
    // feature experimental
    ExcelExporter
} from './webpack.entry.thin.js';
// endregion
